import { getHorariosBySalaIdAndDate } from "../services/salas";

export const fetchHorarios = async (roomId, selectedDate, setSchedules) => {
  try {
    const horarios = await getHorariosBySalaIdAndDate(roomId, selectedDate);
    setSchedules(horarios);
  } catch (error) {
    console.error("Erro ao buscar horários:", error);
  }
};
